<template>
  <div class="tsak-home-cnt">
    <div class="tb-header clear">
      <div class="tb_num fl">
        <div class="num">{{ $i18nUtil.trans("message.ProjectFilter.000","나의 과제 ({cnt} 건)", {cnt: resProjectCount}) }}</div>
        <div class="dividing_line_ty1" v-show="tenantId !='418502'"></div>
        <div class="evaluate-box" v-show="tenantId !='418502'">
          {{ $i18nUtil.trans("entity.projectList.status","진행단계") }}
          <!-- <span class="ico-evaluate-good"></span> {{ $i18nUtil.trans("entity.project.projectStatus.GOOD","정상") }}
          <span class="ico-evaluate-so"></span> {{ $i18nUtil.trans("entity.project.projectStatus.SO","이슈 발생") }}
          <span class="ico-evaluate-delay"></span> {{ $i18nUtil.trans("entity.project.projectStatus.DELAY","보고 필요") }}
          <span class="ico-evaluate-exceeded"></span> {{ $i18nUtil.trans("entity.project.projectStatus.EXCEEDED.002","종료") }} -->
        </div>
        <div class="droplayer icon info tip relative" v-show="tenantId !='418502'">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on">설명</v-btn>
            </template>
            <div class="dropdown-list">
              <div class="tooltip-b tl" style="width: 373px">
                <div v-if="tenantId !== '203'">{{ $i18nUtil.trans("message.ProjectFilter.001","평가정보는 과제/보드 멤버가 수동으로 변경 가능합니다.") }}</div>
                <div v-if="tenantId === '203'">{{ $i18nUtil.trans("message.ProjectFilter.001_1","진행단계는 과제/보드 멤버가 수동으로 변경 가능합니다.") }}</div>
                <div v-if="tenantId !== '203'" v-html="$i18nUtil.trans('message.ProjectFilter.010','평가 기준')"></div>
                <div v-if="tenantId === '203'" v-html="'&lt; '+$i18nUtil.trans('entity.projectList.status','진행단계')+' &gt'"></div>
                <div class="tit">
                  <span class="ico-evaluate-good"></span> {{ $i18nUtil.trans("entity.project.projectStatus.GOOD","정상") }}
                </div>
                <ul class="list-dot white">
                  <li>{{ $i18nUtil.trans("message.ProjectFilter.002","이슈가 없는 상황, 정상적으로 진행 중") }}</li>
                </ul>
                <div class="tit">
                  <span class="ico-evaluate-so"></span> {{ $i18nUtil.trans("entity.project.projectStatus.SO","이슈 발생") }}
                </div>
                <ul class="list-dot white">
                  <li>{{ $i18nUtil.trans("message.ProjectFilter.003","이슈/승인/지원 상황 발생에 따른 협의/의사결정 필요") }}</li>
                  <li>{{ $i18nUtil.trans("message.ProjectFilter.004","상위 관리자 주도 下, 이슈 논의 및 의사결정으로 해결") }}</li>
                </ul>
                <div class="tit">
                  <span class="ico-evaluate-delay"></span> {{ $i18nUtil.trans("entity.project.projectStatus.DELAY","보고 필요") }}
                </div>
                <ul class="list-dot white">
                  <li>{{ $i18nUtil.trans("message.ProjectFilter.005","상위 관리자 선에서 해결 불가능한 사안, 논의 후 보고 안건 선정") }}</li>
                  <li>{{ $i18nUtil.trans("message.ProjectFilter.006","보고 대상자 의사결정 또는 방향성 논의로 해결") }}</li>
                </ul>
                <div class="tit">
                  <span class="ico-evaluate-exceeded"></span> {{ $i18nUtil.trans("entity.project.projectStatus.EXCEEDED.002","종료") }}
                </div>
                <ul class="list-dot white">
                  <li>{{ $i18nUtil.trans("message.ProjectFilter.007","목표 달성(Task 완료)피벗/재편성, 사업 중단") }}</li>
                  <li>{{ $i18nUtil.trans("message.ProjectFilter.008","상위 관리자/보고 대상자와 논의 후 종료") }}</li>
                </ul>
              </div>
            </div>
          </v-menu>
        </div>
      </div>

      <div class="tb_sort fr">
        <input
          type="checkbox"
          name="isFavorite"
          id="isFavorite"
          v-model="isFavorite"
          @change="fireFilterBookmark()"
        />
        <label for="isFavorite">{{ $i18nUtil.trans("button.favorite","즐겨찾기 보기") }}</label>
        <div class="dropdown ty2 relative">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on">{{sort == 'update' ? $i18nUtil.trans("entity.project.search.sort.update","최신순") : $i18nUtil.trans("entity.project.search.sort.projectName","과제명순") }}</v-btn>
            </template>
            <div class="dropdown-list">
                <div class="dropdown-list-item"><div class="tit"><button type="button" @click="filterSort('update')" :class="{active : sort=='update'}">{{ $i18nUtil.trans("entity.project.search.sort.update","최신순") }}</button></div></div>
                <div class="dropdown-list-item"><div class="tit"><button type="button" @click="filterSort('projectName')" :class="{active : sort=='projectName'}">{{ $i18nUtil.trans("entity.project.search.sort.projectName","과제명순") }}</button></div></div>
            </div>
          </v-menu>
        </div>
        <div class="dividing_line_ty1"></div>
        <CommonFilterHomeA @updateCommonFilterHomeA="updateCommonFilterHomeA" :initFilter="initFilter"/>
      </div>
    </div>
    <div class="tab_ty2 new" id="tabs">
      <ul class="tab-menu">
        <li v-for="(tab, index) in tabs" v-bind:class="{active:currentTab===index}" :key="index">
          <button type="button" v-on:click="changeTab(index)">{{tab}}</button>
        </li>
      </ul>
      <div class="tab-content">
        <div v-show="currentTab == 0">
          <ProjectContents
            v-if="projectList.length !== 0"
            :projectList="projectList"
            :unReadComment="unReadComment"
            :loginUserId="loginUserId"
            @getMyProjectList="getMyProjectList"
          />
        </div>
        <div v-show="currentTab == 1">
          <ProjectContentsList
            v-if="projectList.length !== 0"
            :projectList="projectList"
            :unReadComment="unReadComment"
            :loginUserId="loginUserId"
            :projectCommentCountList="projectCommentCountList"
            @getMyProjectList="getMyProjectList"
          /> 
        </div>
      </div>
    </div>

    <!-- //tb-header -->
    <!-- 일반사용자 홈 > 컨텐츠 영역 -->
    <div class="nodata" v-if="projectList.length === 0">
      <div v-if="isInternalUser">
        <div class="txt">{{$i18nUtil.trans("message.ProjectFilter.009","과제를 생성하여 체계적으로 업무를 관리해보세요.")}}</div>
        <button type="button" class="btn-primary-small black" @click="addProject">
          {{$i18nUtil.trans("button.project.add","과제 추가")}}
        </button>
      </div>
      <div v-else>
        <div class="txt">{{$i18nUtil.trans("search.002","참여중인 과제가 없습니다.")}}</div>
      </div>
    </div>

    <!-- <div class="btn_more_box" v-if="count > 0">
      <button
        type="button"
        class="btn-more-ico_small1 down"
        @click="loadMoreProject"
      >
        {{ $i18nUtil.trans("button.project.more","{cnt}건 과제 더보기", {cnt: count}) }}
      </button>
    </div> -->

    <div class="pagination" v-show="pageCount>0">
        <v-pagination
            v-model="page"
            circle
            :length="pageCount"
            :total-visible="10"
        ></v-pagination>
    </div>
  </div>
</template>

<script>
//import axios from "axios";
import SockJS from "sockjs-client";
import Stomp from "webstomp-client";
import ProjectContents from "./ProjectContents";
import ProjectContentsList from "./ProjectContentsList";
import { mapActions, mapMutations, mapState } from "vuex";
import CommonFilterHomeA from "@/components/cowork/common/filter/CommonFilterHomeA";

export default {
  components: {
    /* 일반사용자 홈 > 컨텐츠 영역 */
    ProjectContents,
    ProjectContentsList,
    CommonFilterHomeA
  },
  data() {
    return {
      /* tenantId */
      tenantId : localStorage.getItem("tenantId"),
      /* 정렬순서 */
      sort : "update",
      enabled: true,
      dragging: false,
      /* 상태 필터 값 */
      status: "ALL",
      /* 즐겨찾기 필터 값 */
      isFavorite: false,
      /* 생성/수정자 전체 선택 */
      allSelectedUser: true,
      /* 생성/수정자 선택 */
      selectedUserIds: [],
      /* 생성,수정자 */
      modRegUserList: [],
      /* 리스트 */
      resProjectList: [],
      /* 건 수 */
      resProjectCount: null,
      /* 더 볼수 있는 건 수 */
      count: null,
      /* 필터링 된 리스트 */
      filterProjectList: [],
      /* 넘겨줄 리스트 */
      projectList: [],
      /* 아이디 리스트 */
      projectIdList: {},
      /* 읽지 않은 의견 여부 */
      unReadComment: [],
      todoCountList: [],
      loginUserId: "",
      todoCount: null,
      loader: null,
      loading: false,
      stompClient: null,
      socket : null,

      page: 1,
      pageCount: 0,
      itemsPerPage: 12,

      changeTableData: false,

      // 카드뷰  | 리스트뷰 
      currentTab : 0,
      tabs:[this.$i18nUtil.trans("entity.projectList.card","카드"),this.$i18nUtil.trans("entity.projectList.list","리스트")],
      filterId : null,

      projectCommentCountList:[],
      initFilter:[], 

      projectStatusList:'', // 과제홈 필터 (상태값 : 'GOOD','SO',"DELAY','EXCEEDED') 
      projectGradeList : '' // 과제 홈 필터 (공개 등급 : 'NORMAL','RESTRICT')
    };
  },
  created() {
    EventBus.$off("homeAddOkr");
    EventBus.$on("homeAddOkr", () => {
      this.getMyProjectList();
    });
    let projectMainFavoriteFilterYn = localStorage.getItem("projectMainFavoriteFilterYn");
    if(projectMainFavoriteFilterYn === "true"){
      this.isFavorite = true;
    }
  },
  mounted() {
    //this.initLoader();
    this.connect();
    this.getFilterInfo();
    // this.getMyProjectList();
  },
  beforeDestroy() {
    try { this.stompClient.disconnect(() => {}); } catch (ignore) { }
    try { this.socket.close(); } catch (ignore) { }
    this.connected = false;
  },
  watch: {
    loading: function () {
      if (this.loading) {
        //할 일 기능 재검토 아래 로직 주석 처리 (2021.03.11 leehc)
        //this.getTodoCountOfProject();
      }
    },
    page : function() {
      if(this.changeTableData != true){
        this.changeTableData = true;
      }
      window.scrollTo(0, 0);
    },
    changeTableData : function() {
      let obj = this;
      if(obj.changeTableData == true){
          setTimeout(() => {
              obj.changeTableData = false;
              obj.getMyProjectList();
              obj.setFilterInfo();
          }, 500);
      }
    },
  },
  computed : {
    ...mapState("introInfo", ["isInternalUser"]),
  },
  methods: {
    // initLoader() {
    //   if (!this.loading) {
    //     this.loader = this.$loading.show();
    //   }
    // },
    /* 토스트 메시지 */
    ...mapActions("modals", ["showToast"]),
    /* 모달 팝업 */
    ...mapActions("modals", ["showModal"]),
    /* REST-API */
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    /* 즐겨찾기 목록 갱신 */
    ...mapMutations("project", ["setProjectFavoriteList"]),
    connect() {
      let serverUrl = "/api/cogroup/websocket";
      this.socket = new SockJS(serverUrl, null, {transports: ["websocket"]});
      this.socket.protocol = 'v12.stomp';
      this.stompClient = Stomp.over(this.socket);
      this.stompClient.heartbeat.outgoing = 20000;
      this.stompClient.heartbeat.incoming = 0;
      this.stompClient.reconnect_delay = 5000;
      this.stompClient.debug = (msg) => {
        //console.log("SOCK:", msg);
      };
      this.stompClient.connect(
        { Authorization: localStorage.getItem("Authorization") },
        (frame) => {
          this.connected = true;
          this.subsCribe();
        },
        (error) => {
          console.log(error);
          this.connected = false;
        }
      );
    },
    subsCribe() {
      let obj = this;
      obj.stompClient.subscribe(
        "/api/cogroup/topic/project/subscribe/",
        (message) => {
          let resData = JSON.parse(message.body);
          let flag = resData.data.flag;
          obj.getMyProjectList();
        }
      );
    },
    addProject() {
      this.$emit("addProject");
    },
    /* 필터 창 오픈 */
    openFilter(event) {
      event.target.parentElement.classList.toggle("active");
    },
    // selectAllUserFilter() {
    //   if(this.allSelectedUser) {
    //     this.modRegUserList.forEach(element => {
    //       this.selectedUserIds.push(element.userId);
    //     });
    //   } else {
    //     this.selectedUserIds = [];
    //   }
    //   this.projectFilter();
    // },
    /* 필터( 즐겨찾기 & 상태 & 생성/수정자 ) */
    projectFilter(status, event) {
      let obj = this;
      if (status !== null && status !== undefined) {
        obj.status = status;
      } else {
        status = obj.status;
      }
      let filterList = [];
      let isFavorite = obj.isFavorite;
      let orgProjectList = obj.resProjectList;
      let selectedUserIds = obj.selectedUserIds;
      
      // if(selectedUserIds.length === obj.modRegUserList.length) {
      //   obj.allSelectedUser = true;
      // } else {
      //   obj.allSelectedUser = false;
      // }

      if (event !== null && event !== undefined) {
        event.target.parentElement.classList.toggle("active");
      }

      if (isFavorite) {
        localStorage.setItem("projectMainFavoriteFilterYn", true);
        if (status === "ALL") {
          if (selectedUserIds.length > 0) {
            orgProjectList.forEach(function (project, index, arr) {
              selectedUserIds.forEach(function (userId, index, arr) {
                if (
                  project.favoriteYn === "1" &&
                  (project.modUserId === userId || project.regUserId === userId)
                ) {
                  filterList.push(project);
                }
              });
            });
            obj.filterProjectList = Array.from(new Set(filterList)); //중복 제거
          } else {
            // orgProjectList.forEach(function (project, index, arr) {
            //   if (project.favoriteYn === "1") {
            //     filterList.push(project);
            //   }
            // });
            // obj.filterProjectList = filterList;
            obj.filterProjectList = [];
          }
        } else {

          if (selectedUserIds.length > 0) {
            orgProjectList.forEach(function (project, index, arr) {
              selectedUserIds.forEach(function (userId, index, arr) {
                if (
                  project.favoriteYn === "1" &&
                  project.status === status &&
                  (project.modUserId === userId || project.regUserId === userId)
                ) {
                  filterList.push(project);
                }
              });
            });
            obj.filterProjectList = Array.from(new Set(filterList)); //중복 제거
          } else {
            // orgProjectList.forEach(function (project, index, arr) {
            //   if (project.favoriteYn === "1" && project.status === status) {
            //     filterList.push(project);
            //   }
            // });
            // obj.filterProjectList = filterList;
            obj.filterProjectList = [];
          }
        }
      } else {
        localStorage.setItem("projectMainFavoriteFilterYn", false);
        if (status === "ALL") {
          if (selectedUserIds.length > 0) {
            orgProjectList.forEach(function (project, index, arr) {
              selectedUserIds.forEach(function (userId, index, arr) {
                if (
                  project.modUserId === userId ||
                  project.regUserId === userId
                ) {
                  filterList.push(project);
                }
              });
            });
            obj.filterProjectList = Array.from(new Set(filterList)); //중복 제거
          } else {
            // orgProjectList.forEach(function (project, index, arr) {
            //   filterList.push(project);
            // });
            // obj.filterProjectList = filterList;
            obj.filterProjectList = [];
          }
        } else {
          if (selectedUserIds.length > 0) {
            orgProjectList.forEach(function (project, index, arr) {
              selectedUserIds.forEach(function (userId, index, arr) {
                if (
                  project.status === status &&
                  (project.modUserId === userId || project.regUserId === userId)
                ) {
                  filterList.push(project);
                }
              });
            });
            obj.filterProjectList = Array.from(new Set(filterList)); //중복 제거
          } else {
            // orgProjectList.forEach(function (project, index, arr) {
            //   if (project.status === status) {
            //     filterList.push(project);
            //   }
            // });
            // obj.filterProjectList = filterList;
            obj.filterProjectList = [];
          }
        }
      }
      filterList = [];
      if (obj.filterProjectList.length > 15) {
        obj.count = obj.filterProjectList.length - 15;
        for (let i = 0; i < 15; i++) {
          filterList.push(obj.filterProjectList[i]);
        }
        obj.projectList = filterList;
      } else {
        for (let i = 0; i < obj.filterProjectList.length; i++) {
          filterList.push(obj.filterProjectList[i]);
        }
        obj.projectList = filterList;
        obj.count = 0;
      }
    },
    /* 리스트 조회 */
    getMyProjectList() {
      let obj = this;
      obj.projectList = [];
      
      if(obj.currentTab == 0){
        obj.itemsPerPage = 12;
      }else{
        obj.itemsPerPage = 10;
      }

      let pageParam = obj.page;
      let reqData = {
        url: "/api/cogroup/project/getMyProjectListPaging",
        method: "post",
        params: {
          sort : this.sort,
          limitRow: obj.itemsPerPage,
          page: pageParam - 1,
          isBookmarkChecked: obj.isFavorite,
          statusList: obj.projectStatusList,
          gradeList : obj.projectGradeList
        }
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          if (res.errorCode != null) {
            console.log(res.errorCode);
          } else {
            if (res.result !== null) {
              obj.projectList = res.result.data.content; // 목록 리스트
              obj.resProjectCount = res.result.data.totalElements; // 총 건수
              obj.modRegUserList = res.result.modRegUserList; // 등록 or수정자 목록
              obj.pageCount = res.result.data.totalPages;
              // obj.configProjectList();
              // obj.selectAllUserFilter();
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });

      /* 미조회 의견 존재여부 */
      let cmtReqData = {
        url: "/api/cogroup/project/getUnReadCommentList",
        method: "post",
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(cmtReqData)
        .then((res) => {
          if (res.result && res.result.data) {
            /* 먼저 초기화 시켜줌 */
            obj.loginUserId = res.result.loginUserId;
            obj.unReadComment.splice(0, obj.unReadComment.length);
            res.result.data.forEach(item => {
              if (item.newYn == 1) {
                obj.unReadComment.push(item.projectId);
              }
            });
          }
        })
        .catch(function (err) {
          console.log(err);
        });
        
      /* 의견 카운트 조회  */
      let cmtLReqData = {
        url: "/api/cogroup/project/getCommentCountList",
        method: "post",
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(cmtLReqData)
        .then((res) => {
          if (res.result && res.result.data) {
            this.projectCommentCountList = [];
            res.result.data.forEach((item) => {
              this.projectCommentCountList[item.projectId] = item.count; 
            })
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    // 페이징 처리로 사용 안함 
    // configProjectList() {
    //   let obj = this;
    //   if (obj.projectList.length === 0) {
    //     if (obj.resProjectList.length >= 15) {
    //       for (let i = 0; i < 15; i++) {
    //         obj.projectList.push(obj.resProjectList[i]);
    //       }
    //       obj.count = obj.resProjectCount - 15;
    //     } else {
    //       for (let i = 0; i < obj.resProjectList.length; i++) {
    //         obj.projectList.push(obj.resProjectList[i]);
    //       }
    //       obj.count = 0;
    //     }
    //   } else {
    //     let length = obj.projectList.length;
    //     obj.projectList = [];
    //     for (let i = 0; i < length; i++) {
    //       obj.projectList.push(obj.resProjectList[i]);
    //     }
    //     obj.count = obj.resProjectCount - length;
    //   }
    //   obj.loading = true;
    // },
    /* 할 일 카운트 조회 */
    getTodoCountOfProject() {
      let obj = this;
      if (obj.resProjectList.length > 0) {
        let projectInfo = [];
        obj.resProjectList.forEach((project) => {
          projectInfo.push(project.projectId);
        });
        let reqData = {
          url: "/api/copaper/todo/countProjectTodo",
          method: "post",
          params: {
            projectInfo: projectInfo,
          },
        };
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then((res) => {
            if (res.errorCode !== null) {
            } else {
              if (res.result !== null && res.result !== undefined) {
                let resList = res.result;

                resList.forEach((item, index) => {
                  if (item.targetId === obj.resProjectList[index].projectId) {
                    obj.resProjectList[index].todoCount = item.count;
                  }
                });
              }
            }
          })
          .catch(function (err) {
            console.log(err);
          });
      }
    },
    /* 더보기 클릭 */
    // loadMoreProject() {
    //   let list = [];
    //   let stPoint = null;
    //   let edPoint = null;
    //   let listSize = null;

    //   if (this.status !== "ALL" || this.isFavorite !== false) {
    //     list = this.filterProjectList;
    //     listSize = list.length;
    //     stPoint = listSize - this.count;
    //     edPoint = stPoint + 14;
    //   } else {
    //     list = this.resProjectList;
    //     listSize = list.length;
    //     stPoint = listSize - this.count;
    //     edPoint = stPoint + 14;
    //   }

    //   let distance = listSize - stPoint;
    //   if (distance < 15) {
    //     for (let i = stPoint; i < stPoint + this.count; i++) {
    //       this.projectList.push(list[i]);
    //     }
    //     this.count = 0;
    //   } else {
    //     for (let i = stPoint; i <= edPoint; i++) {
    //       this.projectList.push(list[i]);
    //     }
    //     this.count = this.count - 15;
    //   }
    // },
    //즐겨찾기 보기.
    fireFilterBookmark(){
      let obj = this;
      if(obj.page == 1) {
      obj.changeTableData = true;
      } else {
        obj.page = 1;
      }
    },
    filterSort(sort){
      let obj = this;
      obj.sort=sort;
      if(obj.page == 1) {
        obj.changeTableData = true;
      } else {
        obj.page = 1;
      }
    },
    getFilterInfo(){
      let obj = this;
      let reqData = {
        url: "/api/copaper/filter/getFilterInfo",
        method: "post",
        params: {
          targetId : "PROJECTHOME",
          targetLocation: "PROJECTHOME"
        }
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          if (res.errorCode != null) {
            console.log(res.errorCode);
          } else {
            if (res.result !== null && res.result !== undefined) {
              this.isFavorite = res.result.bookmarkYn == 1 ? true : false;
              this.currentTab = res.result.viewStyle == null ? 0 : res.result.viewStyle == "card" ? 0 : 1;
              this.sort = res.result.sortBy == null ? "update" : res.result.sortBy; 
              this.filterId = res.result.filterId;
              // this.sort = res.result.sortBy | "update"; 
              this.initFilter ={statusList : res.result.status == null ? [] : res.result.status
                              , gradeList : res.result.grade == null ? [] : res.result.grade }
              this.projectStatusList = res.result.status;
              this.projectGradeList = res.result.grade;
              this.getMyProjectList();
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    setFilterInfo(){
      let obj = this;
      let reqData = {
        url: "/api/copaper/filter/setFilterInfo",
        method: "post",
        params: {
          filterId : obj.filterId,
          targetId : "PROJECTHOME",
          targetLocation : "PROJECTHOME",
          sortBy : obj.sort,
          bookmarkYn : obj.isFavorite ? 1 : 0,
          viewStyle : obj.currentTab == 0 ? 'card' : 'list',
          grade : obj.projectGradeList,
          status : obj.projectStatusList
        }
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          if (res.errorCode != null) {
            console.log(res.errorCode);
          } else {
            if (res.result !== null && res.result !== undefined) {
              // console.log(res);
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    changeTab(index){
      let obj = this;
      obj.currentTab = index;
      obj.projectList = [];
      if(obj.page == 1){
        obj.changeTableData = true;
      }else{
        obj.page = 1;
      }
    },
    updateCommonFilterHomeA(filterData) {
      let obj = this;   
      obj.projectStatusList = "";
      obj.projectGradeList = "";
      if(filterData != null){
        filterData.filterStatusList.forEach(function(data){
          obj.projectStatusList += data+";";
        })

        filterData.filterGradeList.forEach(function(data){
          obj.projectGradeList += data+";";
        })

        obj.projectStatusList = obj.projectStatusList.slice(0,-1);
        obj.projectGradeList = obj.projectGradeList.slice(0,-1);
      }else{
        obj.projectStatusList = "";
        obj.projectGradeList = "";
      }

      if(obj.page == 1) {
        obj.changeTableData = true;
      } else {
        obj.page = 1;
      }
    },
  },
};
</script>

<style scoped>
 .selectBoxWidth {
   width: 120px !important;
 }
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/project/base/ProjectFilter.vue